// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Badge/Badge.less
// module id = 186
// module chunks = 2